export default __webpack_public_path__ + "static/media/error.6db752f1.webp";